import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { appUrl } from "../../../constants/url-constants";

const FranchiseMetaTags = ({
    seo
}) => {

    const { default: seoDetails } = seo || {};
    const { title = "", description = "" } = seoDetails || {};

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            <link href={`${appUrl()}/franchise/`} rel="canonical" />
        </Helmet>

    );
};

FranchiseMetaTags.propTypes = {
    seo: PropTypes.object
};
export default FranchiseMetaTags;
